/*!
 * Copyright © 2023-2026. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum ESidePanelContent {
  None,
  DeviceHealthCheck,
  Geofence,
  Ecm
}
